import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Grid,
  Icon,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import clsx from "clsx";
import BillingsTable from "./BillingsTable";
import BillingsFilter from "./BillingsFilter";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid #EEE",
    boxShadow: "0 2px 0 0 rgba(129,129,129,0.10)",
    borderRadius: 10,
  },
  head: {
    padding: "15px 20px",
    borderBottom: "2px solid #F5F5F5",
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
  },
  headTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginRight: 20,
  },
  heading: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 15,
  },
  printLink: {
    fontSize: 12,
    color: theme.palette.common.link,
    marginLeft: "auto",
    padding: 0,
    textTransform: "none",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "transparent",
      opacity: 0.8,
    },
  },
  printIcon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 12,
    marginRight: 8,
    marginTop: 3,
  },
  body: {
    padding: 20,
  },
  divider: {
    marginTop: 20,
    marginBottom: 20,
    backgroundColor: "#F5F5F5",
    height: 2,
  },
}));

const Billings = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.head}>
        <Typography className={classes.headTitle}>Bills and payment</Typography>
      </Box>
      <Box className={classes.body}>
        <Grid container>
          <Grid item xs={12}>
            <Typography className={classes.heading}>
              Search delivery date
            </Typography>
            <BillingsFilter />
            <Divider className={classes.divider} />
            <BillingsTable />
            <Box align="right" mt={1}>
              <Button className={classes.printLink}>
                <Icon className={clsx(["fas fa-print", classes.printIcon])} />
                Print orders
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Billings;
